import React from 'react';

const THOUSAND = Math.pow(10, 3);
const MILLION = Math.pow(10, 6);
const BILLION = Math.pow(10, 9);

export default class NumberFormatter extends React.Component {
  render () {
    let number = this.props.number;

    if (number >= BILLION) {
      number = (number / BILLION).toFixed(2) + 'b';
    }

    if (number >= MILLION && number < BILLION) {
      number = (number / MILLION).toFixed(2) + 'm';
    }

    if (number >= THOUSAND && number < MILLION) {
      number = (number / THOUSAND).toFixed(2) + 'k';
    }

    if (this.props.disableTooltip) {
      return (<span>{number}</span>);
    }

    return (<span data-tip={this.props.number}>{number}</span>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/NumberFormatter.js